import styled from 'styled-components'

export const Container = styled.div`
  padding: 48px 40px;
  display: flex;
  width: 580px;
  height: 330px;
  align-items: end;
  justify-content: space-between;
`

export const Title = styled.h1`
  color: #2e2d37;
  font-weight: 500;
  font-size: 20px;
  width: 356px;
`

export const Description = styled.p`
  width: 356px;
  margin-top: 16px;
  color: #2e2d37;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 32px;
`

export const Warning = styled.span`
  color: #696977;
  font-size: 16px;
  font-weight: 400;
`

export const ButtonsGroup = styled.div`
  margin-top: 32px;
  button {
    &:first-child {
      span {
        color: #696977;
        border-color: #696977;
      }
    }
    margin-right: 16px;
    span {
      width: 120px;
      font-size: 12px;
      justify-content: center;
    }
  }
`
